import "./index.css";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "mdb-react-ui-kit/dist/css/mdb.min.css";

import "antd/dist/antd.css";

import { BrowserRouter } from "react-router-dom";
import { GlobalStateProvider } from "./crm/utils/GlobalStateContext";
import { persistor, store } from "./crm/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

//
const RootComponent = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <GlobalStateProvider>
            <App />
          </GlobalStateProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootComponent />);
reportWebVitals();
